import httpClient from '@/api/httpClient';

const getPrices = treatment => httpClient.post('/api/webShop/showProductPrices', treatment);

export { getPrices };
